var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_vm._v(_vm._s(_vm.reportName)+": ")]),_c('v-col',[_c('v-btn',{on:{"click":_vm.download}},[_vm._v("Download")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }